import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import { State } from "../../store";
import useTickets from "./hooks/useTickets";
import LimitedTicketBlock from "./LimitedTicketBlock";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "./style.scss";

const LimitedTicketColorPage: React.FC = () => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration.componentList);
  const messageColors = useSelector((state: State) => state.config.configuration.message_tickets);

  const { colorGroup, requestGetColorGroups } = useTickets();

  useEffect(() => {
    requestGetColorGroups();
  }, []);

  return (
    <React.Fragment>
      <div className="container">
        <div className="headline">
          {saleConfiguration && (
            <React.Fragment>
              {saleConfiguration.map((item) => (
                <React.Fragment>{item.id === "Colors" && <h1>{item.name}</h1>}</React.Fragment>
              ))}
            </React.Fragment>
          )}

          <div className="line"></div>

          {messageColors && (
            <React.Fragment>
              {messageColors.length > 12 ? (
                <div className="alert alert-comment">
                  <article dangerouslySetInnerHTML={{ __html: messageColors }}></article>
                </div>
              ) : (
                <React.Fragment></React.Fragment>
              )}
            </React.Fragment>
          )}

        </div>

        {colorGroup && (
          <React.Fragment>
            {colorGroup.map((item, index) => (
              <div key={index}>
                <LimitedTicketBlock item={item} sortType="colorGroup" />
              </div>
            ))}
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default LimitedTicketColorPage;
